<template>
  <div class="user-change-addr">
    <div class="head" ref="headRef">
      <div class="head-search">
        <div class="isPopup" v-if="isPopup"><van-icon @click="isBack" name="arrow-left" /></div>
        <!--  v-scrolltop -->
        <van-search placeholder="请输入搜索关键词" v-model="searchKey" show-action
                    @search="onSearch" @clear="onSearch" shape="round">
          <div slot="action" @click="onSearch">搜索</div>
        </van-search>
      </div>
      <div class="choose-part" v-if="chooseData.length">
        <div class="title">
          <van-icon name="location"></van-icon>
          当前地址
        </div>
        <div class="choose-group">
          <div class="choose-item" v-for="(item, index) in chooseData" :key="item.Id">
            <div @click="changeChoose(item, index)">{{item.Name}}</div>
            <van-icon name="success" v-if="index === chooseData.length - 1" color="#48BD4B"></van-icon>
          </div>
        </div>
      </div>
    </div>



    <div class="change-content" :style="{height: contentHeight + 'px'}">
      <van-loading v-if="listLoading" color="#3494F5"/>
      <div v-else>
        <van-cell v-for="(item, index) in list" :key="item.Id" @click="checkedItem(item)">{{item.Name}}<span v-if="item.ExtendName">（{{item.ExtendName}}）</span></van-cell>
      </div>
    </div>
    <div class="sure_btn" @click="submitChangeAddr">确定更换</div>
    <div v-if="listLoading" class="loading-mask-custom"></div>
  </div>
</template>

<script>
import {getCookie, removeCookie, setCookie} from "@/utils/cookie";

  export default {
    name: 'userChangeAddr',
    props: {
      isPopup: {
        type: Boolean,
        default: () => false
      },
      isCache: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return{
        searchKey: '',
        chooseData: [],
        contentHeight: 0,
        list: [],
        listLoading: false,
        searchParams: {}
      }
    },
    computed: {
    },
    methods: {
      changeChoose(item,index){
        this.chooseData = this.chooseData.slice(0, index)
        this.searchParams =  {}
        if (index > 0) {
          if (index === 1){
            this.searchParams.RegionId = this.chooseData[0].Id
          } else {
            this.searchParams.RegionId = this.chooseData[0].Id
            this.searchParams.ParentId = this.chooseData[this.chooseData.length -1].Id
          }
        }
        this.getList()
      },
      // 选中内容
      checkedItem(item) {
        //当chooseData长度为0是，当前选中为校区
        const chooseLength = this.chooseData.length
        const newItem = {
          Name: item.Name,
          ExtendName: item.ExtendName,
          Id: item.Id,
          IsLeaf: chooseLength === 0 ? false : item.IsLeaf
        }
        this.searchParams = {}
        if (chooseLength === 0) {
          this.searchParams.RegionId = item.Id
        }else {
          this.searchParams.RegionId = this.chooseData[0].Id
          this.searchParams.ParentId = item.Id
        }
        this.chooseData.push(JSON.parse(JSON.stringify(newItem)))
        this.getContentHeight()
        this.getList()
      },
      async getList() {
        this.listLoading = true
        const params = this.searchParams
        params.Name = this.searchKey
        this.list = []
        try {
          let url = this.chooseData.length === 0 ? '/BizMemberRegion/AllList' : '/BizMemberDormitory/AllList'
          const { Data } = await this.$post(url,params)
          this.list = Data
          this.listLoading = false
        }catch (e) {

        }

      },
      getContentHeight() {
        this.$nextTick(() => {
          const contentHeight = document.getElementsByClassName('user-change-addr')[0].getClientRects()[0].height
          const headHeight = this.$refs.headRef.getClientRects()[0].height
          this.contentHeight = contentHeight - headHeight - 55
        })
      },
      // 返回按钮
      isBack(){
        this.$emit('close')
        if (this.isCache) setCookie('userAddressCache', JSON.stringify(this.chooseData))
      },
      // 搜索
      onSearch(e){
        this.getList()
      },
      submitChangeAddr(){
        if (this.isPopup) {
          if (this.list.length) {
            this.$toast("当前地址暂未开通服务，请重新选择！");
            return false;
          }
          this.$emit('changeAddr', this.chooseData)
          removeCookie('userAddressCache')
        }
      }
    },
    mounted() {
      if (this.isCache){
        const userAddressCache = getCookie('userAddressCache')
        if (userAddressCache) {
          this.chooseData = JSON.parse(userAddressCache)
          this.searchParams = {}
          this.searchParams.RegionId = this.chooseData.length ? this.chooseData[0].Id : ''
          if (this.chooseData.length > 1) {
            this.searchParams.ParentId = this.chooseData[this.chooseData.length - 1].Id
          }
        }
      }
      this.getList()
      this.getContentHeight()
    }
  }

</script>

<style scoped lang="less">
.user-change-addr{
  height: 100vh;
  overflow: hidden;
  .head{
    .head-search{
      height: 64px;
      display: flex;
      width: 100%;

      .van-search{
        width: 100%;
      }
      .isPopup{
        height: 64px;
        width: 30px;
        line-height: 64px;
        flex-shrink: 0;
        text-align: center;
        z-index: 20;
      }
    }

    .choose-part{
      border-bottom: 3px solid #F2F2F2;

      .title{
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        background-color: #F2F2F2;
      }
      .choose-group{
        padding: 6px 15px;
      }
      .choose-item{
        color: #333333;
        padding: 4px 0;
        display: flex;
        align-items: center;
        div{
          width: 100%;
        }
        .van-icon{
          flex-shrink: 0;
          width: 14px;
        }

        &:first-child{
          >div{
            font-weight: bold;
          }
        }
      }
    }
  }

  .change-content{
    width: 100%;
    overflow-y: auto;
  }

  .sure_btn{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #48bd4b;
    text-align: center;
    height: 48px;
    color: #fff;
    line-height: 48px;
    font-size: 16px;
  }


  .loading-mask-custom{
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10;
  }


  .van-loading{
    z-index: 20;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }

  .van-search__action:active{
    background-color: transparent!important;
  }
}
</style>
